import { GoodPracticeListHeader } from "./components/GoodPracticeListHeader";

export default GoodPracticeListHeader;